import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon", "button"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")
    
    // Rotate the caret icon
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180")
    }
  }

  connect() {
    document.addEventListener("click", this.closeOnClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
  }

  closeOnClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      
      // Reset icon rotation when closing
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove("rotate-180")
      }
    }
  }
}
